@import '@alfalab/core-components-vars/src/no-typography-index.css';
@import '../../calendar/src/vars.css';

.component {
    width: var(--calendar-width);
    height: var(--calendar-height);
    position: relative;
}

.calendarVisible {
    height: auto;
}

.skeleton {
    display: flex;
    flex-direction: column;
    padding: var(--gap-16);
    pointer-events: all;
    box-sizing: border-box;
    position: absolute;
    transition: 0.2s ease;
    left: var(--gap-0);
    top: var(--gap-0);
    width: 100%;
    height: 100%;
    background-color: var(--color-light-modal-bg-primary);
    background-clip: content-box;
}

.header {
    height: 48px;
    margin-bottom: var(--gap-20);
}

.weekDays {
    height: 12px;
    margin-bottom: var(--gap-16);
}

.row {
    height: 32px;

    & + .row {
        margin-top: var(--gap-10);
    }
}

.enter,
.enterActive,
.exit {
    opacity: 1;
}

.exitActive {
    opacity: 0;
}
